module.exports = __webpack_public_path__ + "img/shopify-card.adb515ac.png";